import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import DashboardFooter from "./DashboardFooter";

// import './Dashboard.css'
import { useDispatch } from "react-redux";
import { setPage } from "../../Redux/ActionCreater";
const CommonLayout = ({ children, sidebar = true }) => {
  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPage("dashboard"));
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container-scroller">
      <DashboardHeader sidebar={sidebar} />
      <div className="container-fluid page-body-wrapper ">
        {" "}
        {sidebar && <Sidebar />}
        <div
          className={
            sidebar ? "main-panel" : "main-panel full-width fullwidth-w-sidebar"
          }
        >
          {children}
          {sidebar && <DashboardFooter />}
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
